// Действие: начало установки WebSocket соединения
export const WS_START: 'WS_START' = 'WS_START';
// Действие: успешное установление WebSocket соединения
export const WS_SUCCESS: 'WS_SUCCESS' = 'WS_SUCCESS';
// Действие: возникла ошибка при установке WebSocket соединения
export const WS_ERROR: 'WS_ERROR' = 'WS_ERROR';
// Действие: WebSocket соединение закрыто
export const WS_CLOSED: 'WS_CLOSED' = 'WS_CLOSED';
// Действие: запрос на получение данных о заказах через WebSocket
export const WS_GET_ORDERS: 'WS_GET_ORDERS' = 'WS_GET_ORDERS';
